export class InfectedExcludePath {
    'id';
    'path';
    'providerResourceId';
    'type';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SecurityScanExclusionPathType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InfectedExcludePath.attributeTypeMap;
    }
    constructor() {
    }
}
